module.exports = __webpack_public_path__ + "static/media/ao.b69218a9.svg";